import { DocumentPosition } from "./document-position.model";
import { _ } from "@icc/shared/helpers";

export interface ComplaintPosition extends DocumentPosition {
    type: 'defect',

    /**
     * Id typu produktu
     */
    complaintProductTypeId: number;

    /**
     * Typ produktu
     */
    complaintProductType: string;

    /**
     * Numer seryjny produktu
     */
    serialNumber?: string;

    /**
     * Czy numer seryjny jest nieprawidłowy
     */
    invalidSerialNumber?: boolean;

    /**
     * Numer zamówienia
     */
    orderNumber?: string;

    /**
     * Numer faktury
     */
    invoiceNumber?: string;

    /**
     * Numer pozycji zamówienia
     */
    orderPositionNumber?: string;

    /**
     * Numer zamówienia do dystrybutora/producenta
     */
    distributorOrderNumber?: string;

    /**
     * Numer pozycji zamówienia do dystrybutora/producenta
     */
    distributorOrderPositionNumber?: string;

    /**
     * Data zauważenia usterki
     */
    defectDate?: Date | null;

    /**
     * Typ dokumentu
     */
    complaintDocumentType?: 'serialNumber' | 'invoiceNumber' | 'orderNumber' | null;

    /**
     * Informacja o sposobie obsługi usterki
     */
    defectMaintenance: number | null;

    /**
     * Do weryfikacji
     */
    toVerify: boolean;

    /**
     * Id dokumentu do którego przeniesiono pozycję
     */
    movedToDocumentId?: string | null;

    /**
     * UUID oryginalnej pozycji, z której skopiowano (przy podziale zgłoszenia)
     */
    copiedFromPositionId?: string | null;

    /**
     * Numer pozycji w reklamacji
     */
    index: number;

    /**
     * Id kategorii usterki
     */
    complaintCategoryId: number;

}

export type ComplaintPositionDTO = Omit<
    ComplaintPosition,
    'configuration' | 'department' | 'photos' | '$dirty' | 'createdServer' | 'title' | 'slaves' | 'masters'
> & {
    title?: string;
    configuration?: string;
    priceDiscounts?: string;
    department?: string;
    photos?: string;
    slaves?: string;
    masters?: string;
};


export const ComplaintPositionNonReadableProps = [
    'id',
    'uuid',
    'externalSource',
    'parentId',
    'rootId',
    'documentId',
    'type',
    'created',
    'modified',
    'createdServer',
    'modifiedServer',
    'rootCreated',
    'deletedAt',
    'isDeleted',
    'machineId',
    'errors',
    '$dirty',
    'department',
    'photos',
    'slaves',
    'masters',
    'invalidSerialNumber',
    'title',
    'complaintProductTypeId',
    'toVerify',
    'movedToDocumentId',
    'copiedFromPositionId',
    'index',
    'complaintCategoryId',
] as const satisfies readonly (keyof ComplaintPosition)[];

export const ComplaintPositionReadablePropsNames: Record<Exclude<keyof ComplaintPosition, typeof ComplaintPositionNonReadableProps[number]>, string> = {
    externalId: _('COMPLAINT_POSITION|Zewnętrzne ID'),
    isInvalid: _('COMPLAINT_POSITION|Nieprawidłowa'),
    description: _('COMPLAINT_POSITION|Opis'),
    name: _('COMPLAINT_POSITION|Nazwa'),
    quantity: _('COMPLAINT_POSITION|Ilość'),
    configuration: _('COMPLAINT_POSITION|Miejsce wystąpienia usterki'),
    complaintProductType: _('COMPLAINT_POSITION|Typ produktu'),
    serialNumber: _('COMPLAINT_POSITION|Numer seryjny'),
    orderNumber: _('COMPLAINT_POSITION|Numer zamówienia'),
    invoiceNumber: _('COMPLAINT_POSITION|Numer faktury'),
    orderPositionNumber: _('COMPLAINT_POSITION|Numer pozycji zamówienia'),
    defectDate: _('COMPLAINT_POSITION|Data zauważenia usterki'),
    complaintDocumentType: _('COMPLAINT_POSITION|Typ dokumentu'),
    defectMaintenance: _('COMPLAINT_POSITION|Informacja o sposobie obsługi usterki'),
    distributorOrderNumber: _('COMPLAINT_POSITION|Numer zamówienia pierwotnego (do producenta od dystrybutora)'),
    distributorOrderPositionNumber: _('COMPLAINT_POSITION|Numer pozycji w zamówieniu do producenta od dystrybutora'),
};